import { render } from "./News02.vue?vue&type=template&id=2d3374ff"
import script from "./News02.vue?vue&type=script&lang=js"
export * from "./News02.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__